import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { YearMonthFormatPipe } from './year-month-format.pipe'
import { StageFormatPipe } from './stage-format.pipe'
import { SafePipe } from './safe.pipe'
import { AuthImagePipe } from './auth-image.pipe'
import { ImageUrlPipe } from '@app/pipes/image-url.pipe'
import { LinkifyFormatPipe } from './linkify-format.pipe'

const LIST_PIPE = [
    YearMonthFormatPipe,
    StageFormatPipe,
    SafePipe,
    AuthImagePipe,
    ImageUrlPipe,
    LinkifyFormatPipe,
]

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
        ...LIST_PIPE,
    ],
    declarations: [
        ...LIST_PIPE,
    ],
})
export class PipeModule {
}



// WEBPACK FOOTER //
// ./src/app/pipes/pipe.module.ts